import { Nullish } from '~/@types/generic'
import {
  PRODUCT_SIZES,
  PRODUCT_TAGS,
  PRODUCT_TYPES,
  ProductType,
} from '~/lib/constants'

export function getProductTypeFromTags(tags: Nullish<string[]>): ProductType {
  const defaultType = PRODUCT_TYPES.DEFAULT

  for (const [key, value] of Object.entries(PRODUCT_TAGS)) {
    if (tags.includes(value) && PRODUCT_TYPES[key]) {
      return PRODUCT_TYPES[key]
    }
  }

  return defaultType
}

export function getProductSizeFromTags(
  tags,
): (typeof PRODUCT_SIZES)[keyof typeof PRODUCT_SIZES] {
  for (const [key, value] of Object.entries(PRODUCT_SIZES)) {
    if (tags.includes(value)) {
      return PRODUCT_SIZES[key]
    }
  }
}
